import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RenderInAppActionsSecondaryDirective } from 'app-shell-ui';
import { PunchoutAuthenticationHeaderComponent } from 'punchout-ui';

@Component({
  selector: 'ideal-punchout-application-components-provider',
  imports: [PunchoutAuthenticationHeaderComponent, RenderInAppActionsSecondaryDirective],
  standalone: true,
  templateUrl: './punchout-application-components-provider.component.html',
  styleUrl: './punchout-application-components-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PunchoutApplicationComponentsProviderComponent {}
